import React from 'react';

export const SEOContent: React.FC = () => {
  return (
    <div className="sr-only" aria-hidden="true">
      {/* SEO Content for search engines */}
      <h1>Editor de Prompt IA Gratuito - Aldeia Viva</h1>
      <h2>Crie Prompts Eficazes para Inteligência Artificial</h2>
      <p>
        O Editor de Prompt IA da Aldeia Viva é uma ferramenta gratuita e minimalista 
        para criar, otimizar e organizar seus prompts de inteligência artificial. 
        Melhore seus resultados com ChatGPT, Claude, Gemini e outras IAs.
      </p>
      
      <h3>Funcionalidades Principais</h3>
      <ul>
        <li>Interface minimalista e elegante</li>
        <li>Modo foco para concentração máxima</li>
        <li>Auto-save inteligente</li>
        <li>Templates de prompt pré-configurados</li>
        <li>Contador de tokens em tempo real</li>
        <li>Histórico de versões automático</li>
        <li>Export rápido de prompts</li>
        <li>Toolbar flutuante para formatação</li>
      </ul>

      <h3>Como Usar o Editor de Prompt IA</h3>
      <p>
        1. Digite ou cole seu prompt no editor<br/>
        2. Use templates com "/" para prompts pré-configurados<br/>
        3. Monitore tokens em tempo real<br/>
        4. Active o modo foco com ⌘F<br/>
        5. Salve automaticamente ou exporte com ⌘E
      </p>

      <h3>Templates Disponíveis</h3>
      <ul>
        <li>Prompt do Sistema (/system)</li>
        <li>Revisão de Código (/review)</li>
        <li>Explicação de Código (/explain)</li>
        <li>Correção de Bugs (/bug)</li>
        <li>Otimização (/optimize)</li>
        <li>Documentação (/docs)</li>
      </ul>

      <h3>Compatibilidade com IAs</h3>
      <p>
        Funciona perfeitamente com ChatGPT, Claude, Google Gemini, Microsoft Copilot, 
        e outras ferramentas de inteligência artificial. Otimize seus prompts para 
        melhores resultados em qualquer plataforma de IA.
      </p>
    </div>
  );
};